export const getMessages = (t,data) => {
    const getErrorsMessages = (items, type) => {
        if(items && items.length > 0) {
            return `${type === 'validity' ? '' : t(`${type}Error`) + ': '}${items.map((item) => item.message).join(', ')}. `;
        }
        return '';
    };
  
    const [extrasMessages, paymentsMessages, ticketPriceMessages, validityMessages] = ['extras', 'payments', 'ticketPrice', 'validity'].map((type) =>
        getErrorsMessages(data[type], type)
    );

    return `${extrasMessages}${paymentsMessages}${ticketPriceMessages}${validityMessages}`;
};
  
export const hasError = (errors) => {
    for(const key in errors) {
        if(Array.isArray(errors[key]) && errors[key].length > 0) {
            return true;
        }
    }
    return false;
};